import { removeIndex } from './removeIndex';

/**
 * Remove a value of an array without modifying the original.
 * If the value does not exist in the array, a shallow clone of the original is returned.
 * @param arr
 * @param value
 */
export const removeValue = <T>(arr: T[], value: T) => {
  const index = arr.indexOf(value);
  return removeIndex(arr, index);
};
